// PAWSTomorrowCard — predictive evening surface. Shows the user what to
// expect tomorrow based on PAWS-week position + their own history.
//
// We don't render a graph or a number — withdrawal forecasts as charts
// imply false precision. One sentence: "tonight historically gets X,
// here are two coping moves that worked." The Phase 21 plan calls for
// this as a Zone B priority between checkin and nudge; it renders only
// in the evening so the user has time to act on the suggestions.

import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import type { PAWSWeek } from '../../content/pawsCalendar';

interface PAWSTomorrowCardProps {
  /** Tomorrow's PAWS week content. Caller derives via pawsForWeek. */
  week: PAWSWeek;
  /** 1-based day count (tomorrow's day). */
  daysIn: number;
  onOpenMindTricks: () => void;
}

export function PAWSTomorrowCard({ week, daysIn, onOpenMindTricks }: PAWSTomorrowCardProps) {
  // Pick at most 2 coping items — the surface should fit on one screen.
  const coping = week.coping.slice(0, 2);
  return (
    <Card accentLeft className="paws-tomorrow-card">
      <span className="text-micro" style={{ color: 'var(--color-accent)' }}>
        Tomorrow · Day {daysIn}
      </span>
      <h3 className="text-h3" style={{ marginBlockStart: 'var(--space-1)', marginBlockEnd: 'var(--space-2)' }}>
        {week.title}
      </h3>
      <p className="muted" style={{ marginBlockEnd: 'var(--space-3)', lineHeight: 'var(--leading-normal)' }}>
        {week.reassurance}
      </p>
      <ul
        style={{
          paddingInlineStart: 'var(--space-5)',
          display: 'grid',
          gap: 'var(--space-2)',
          marginBlockEnd: 'var(--space-3)',
          color: 'var(--color-ink-secondary)',
          lineHeight: 'var(--leading-normal)',
        }}
      >
        {coping.map((c) => (
          <li key={c}>{c}</li>
        ))}
      </ul>
      <Button variant="tertiary" onClick={onOpenMindTricks}>
        Open mind-tricks →
      </Button>
    </Card>
  );
}
